import apiClient from './client'

/**
 * Переход из мини-приложения в бота с контекстом экрана (S16).
 * Сервер выдаёт одноразовый непрозрачный код на 15 минут; бот принимает его по
 * ссылке ?start=<start_param> только от того же пользователя. В ссылке нет ни
 * имён, ни ID.
 */

export interface HubContextLinkRequest {
  assistant_id: string
  channel: 'telegram' | 'max'
  kind: 'none' | 'group' | 'session' | 'athlete'
  group_id?: string
  athlete_id?: string
  /** У занятия: YYYY-MM-DD */
  date?: string
  /** У занятия: HH:MM, пусто у занятия без времени */
  start_time?: string
}

export interface HubContextLinkDTO {
  /** ctx_<код> - параметр start ссылки на бота */
  start_param: string
  expires_at: string
  /** Что бот покажет и добавит к вопросу */
  label: string
}

export const hubContextApi = {
  /** POST /api/v1/hub/context-links */
  create: async (body: HubContextLinkRequest): Promise<HubContextLinkDTO> => {
    const response = await apiClient.post<HubContextLinkDTO>('/hub/context-links', body)
    return response.data
  },
}
